import * as lookup from "../../../static/lookup.json"
import * as moment from "moment"
import { dateFormat1 } from "../../shared/constant"
import * as journeyCodes from "../../../static/page-section-mapper.json"
import { applyComma, lineCapital }  from '../../shared/functions'
import { MD5 } from "crypto-js"
import * as dataLayerLookup from '../../../static/dataLayerEventTrigger.json'
export const getStateFromCode = (stateCode) => {
    console.log(stateCode)
    const options = lookup["state"][0]
    return options[stateCode]
}

export const getValueFromLookup = (lookupKey, value) => {
    if(lookupKey === "" || value === ""){
        return null
    }
    const options = lookup?.[lookupKey]?.[0]
    return lookupKey === "countryCodeToCountry" ? options?.[value]  ?? "" : (options?.[value] ?? '') || null
}


export const getValueFromLookup2 = (lookupKey, value) => {
    if(lookupKey === "" || value === ""){
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    return options? options[value] : "NA"
}

export const getDateInFormat = (dateInEpoch) => {
    return moment.unix(dateInEpoch).utcOffset("+05:30").format(dateFormat1)
}

export const findRiderSA = (riderName, rider) => {
    if(!riderName || !rider || (rider.length === 0)){
        return "NA"
    }
    let riderIndex = rider.findIndex((element) => element.name === riderName)
    if(riderIndex !== -1){
        return  applyComma(rider?.[riderIndex]?.["ca"] ?? '')
    }else{
        return "NA"
    }
}


export const findRiderSAPercent = (riderName, rider,lookupKey, percentageName) => {
    if(!riderName || !rider || (rider.length === 0) || percentageName =='' || lookupKey==''){
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    // return options? options[value] : "NA"
    if(!options)
    return 'NA'
    let riderIndex = rider.findIndex((element) => element.name === riderName)
    if(riderIndex !== -1){
        return  options[rider?.[riderIndex]?.[percentageName]] ?? ''
    }else{
        return "NA"
    }
}

export const getAge = (dateInEpoch) => {
    if(!dateInEpoch){
        return ""
    }
    let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
    let timeleft = currentDateInEpoch - dateInEpoch
    let days = Math.floor(((timeleft / 60) / 60) / 24)
    return Math.floor(days/365)
}

export const getLastPageAndLastSection = (currentPageIndex, currentSectionIndex, totalSectionsInCurrentPage) => {
    if(currentSectionIndex   + 1 < totalSectionsInCurrentPage){
        return {
            lastPage: currentPageIndex,
            lastSection :  currentSectionIndex + 1
        }
    }else{
        return {
            lastPage: currentPageIndex + 1,
            lastSection: 0
        }
    }
}

export const findCurrentJourneyCode = (pageId, sectionId) => {
    return Object.keys(journeyCodes).find(code => {
        if(journeyCodes[code].pageId === pageId && journeyCodes[code].sectionId === sectionId){
            console.log(journeyCodes[code], code)
            return code
        }
    })
    
}
export const getKeyFromValueLookup = (lookupKey, value) => {
    if(lookupKey === "" || value === ""){
        return "NA"
    }
    const options = lookup?.[lookupKey]?.[0]
    let channel = "HSBC"
    Object.keys(options).forEach(key => {
        if(options[key]  === value){
            channel = key
        }
    })
    return channel
}

export const productRenderChecker = (valuesInNvest, valueInConditionState) => {
    if(valuesInNvest.includes(",")){
        let valueArray = valuesInNvest.split(",")
        return valueArray.some(element => element === valueInConditionState)
    }else{
        return valuesInNvest === valueInConditionState
    }
}

export const getValueFromJourney = (lookupKey, value) => {
    if( lookupKey === "" || value === "") {
        return "NA"
    }
    console.log(lookupKey, value, "check")
    let values = lookupKey?.[0]
    return lookupKey[0] === "countryCodeToCountry" ? values?.[value]  ?? "" : (values?.[value] ?? '') || "null"
}

export const getRiderInstPrem = (riders, riderName) => {
    if(riders.length === 0){
        return 0
    }
    if(!riderName){
        return 0
    }

    let rider = riders.find(element => element.name === riderName)
    return rider?.instPrem || 0
}

export const getRiderInstPremTotal = (riders) => {
    if(riders.length === 0){
        return 0
    }
    let total = riders.reduce((a,b) => {
        console.log(a,b)
        return a + Number(b.instPrem)
    } , 0)
    return total?.toFixed(2)
}

export const getSourceFromChannel = (channel) => {
    if(!channel){
        return "I"
    }else if(["A", "C"].includes(channel)){
        return "I"
    }else{
        let MediaPartnerCodes = lookup["MediaPartnerCode"]
        let foundIndex = MediaPartnerCodes.findIndex(element => element.ITEM_CODE === channel)
        if(foundIndex !== -1){
            return MediaPartnerCodes[foundIndex]?.SOURCE
        }else{
            return "I"
        }
    }
}

export const isEquitasChannel = channel => ["EQUITAS", "equitas", "36"].includes(channel)


export const DataLayerIntegration = (allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyStateData ) => {
    console.log(journeyStateData);
    var allJourneyData = allJourneyDataResponse
    console.log(allJourneyData)
    const dateofbirth = allJourneyData?.lifeAssuredDetails?.dob;
    const spouseDateOfBirth = allJourneyData?.spouseDetails?.dob
    const nomineeDateOfBirth = allJourneyData?.nominees?.[0]?.dob
    const emailID = allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId;
    const mobileNo = allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo;
    let encryptedEmail  = emailID? MD5(emailID)?.toString() : ''
    let encryptedMobileNo = mobileNo? MD5(mobileNo)?.toString() : ''
    const policyTerm = Number(allJourneyData?.productDetails?.policyTerm) || "";
    const riders = allJourneyData?.productDetails?.riders?.rider
    var optionalBuiltInCoverArray = []
    var optionalBuiltInCover =''
    // let addOnsCalc
    var spouseOptionalBuiltInCoverArray = []
    var spouseOptionalBuiltInCover = ''
    if(riders && riders.length){
        console.log(lookup['laRiders'], lookup['spouseLaRiders'])
        riders.forEach(rider=>{
            if(lookup['laRiders'][0][rider.name])
            {
                optionalBuiltInCoverArray.push(lookup['laRiders'][0][rider.name])
            }
            if(lookup['spouseLaRiders'][0][rider.name])
            {
                spouseOptionalBuiltInCoverArray.push(lookup['spouseLaRiders'][0][rider.name])
            }
        })
        optionalBuiltInCover = optionalBuiltInCoverArray.join('_')
        spouseOptionalBuiltInCover = spouseOptionalBuiltInCoverArray.join('_')
    //   addOnsCalc = riderNames.join("_")
    }
    var spouse = allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" ? "YES" : "NO"
    var PremiumAmount = Number(allJourneyData?.basicDetails?.premium) || Number(allJourneyData?.premium) || "";
    var ProductCode = '90073';
    var products = [];
    products.push({
      'id': ProductCode,                               //Product Code
      'name': 'iSelect Smart360 Term Plan',   //name of the Product
      'category': 'Term',                     //Category of the Product
      'price': allJourneyData?.basicDetails?.premium || allJourneyData?.premium,                  //Product Price
      'quantity': '1'                         //Number of Products Purchased
    })
    const nomineeEmailId = allJourneyData?.nominees?.[0]?.["contactDetails.emailId"] || allJourneyData?.nominees?.[0]?.contactDetails?.emailId
    let spouseCover
    // if(journeyStateData?.lastPage === 0 && journeyStateData?.lastSection > 5){
    //     if(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02"){
    //         spouseCover = "YES"
    //     }else if(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "01"){
    //         spouseCover = "NO"
    //     }else{
    //         spouseCover = ""
    //     }
    // }else if(journeyStateData?.lastPage > 0){
        if(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02"){
            spouseCover = "YES"
        }else if(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "01"){
            spouseCover = "NO"
        }else{
            spouseCover = ""
        }
    // }
    var dynamicEvent
    var clientId
    try {
      let cookies = document.cookie
      let cookieArray = cookies.split(";")
      if (cookieArray && cookieArray.length) {
          let gaTagCookie = cookieArray.find(element => {
          if (element.includes("_ga=")) {
            return element.split(".")
          }
        })
        if (gaTagCookie) {
            let gaTagCookieSplit = gaTagCookie.split(".")
            if (gaTagCookieSplit && gaTagCookieSplit.length) {
                clientId = `${gaTagCookieSplit[gaTagCookieSplit.length - 2]}.${
                    gaTagCookieSplit[gaTagCookieSplit.length - 1]
                }`
          } else {
            clientId = ""
        }
        } else {
          clientId = ""
        }
    } else {
        clientId = ""
    }
    } catch (err) {
      console.log("Error geting google tag", "err")
    }
    let totalMonthlyPremium 
    var tax = Number(PremiumAmount - Math.round(PremiumAmount/1.18))
    try{
        if(PremiumAmount !== ""){
            if(allJourneyData?.productDetails?.premiumFrequency === "12" ){
                totalMonthlyPremium = Number(PremiumAmount/12)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "01"){
                totalMonthlyPremium = Number(PremiumAmount)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "03"){
                totalMonthlyPremium = Number(PremiumAmount/4)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "06"){
                totalMonthlyPremium = Number(PremiumAmount/6)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "SINGLE PREMIUM"){
                totalMonthlyPremium = Number((PremiumAmount/policyTerm)/12)
            }
        }
        else{
            totalMonthlyPremium = ""
        }
        }catch(err){
        console.log(err,"premium error")
    }
    var monthlyPremium
    var premium
    if(totalMonthlyPremium){
        monthlyPremium = (totalMonthlyPremium - tax)
        premium = (totalMonthlyPremium * 12)
    }else{
        monthlyPremium = ""
        premium = ""
    }
    var userType
    if(allJourneyData?.basicDetails?.existingCustomer){
        userType = allJourneyData?.basicDetails?.existingCustomer === "N" ? "New User" : "Returning User"
    }else{
        userType = ""
    }
    window.dataLayer = window.dataLayer || [];
    let lastDataLayerElement
    if(window.dataLayer.length){
        lastDataLayerElement = window.dataLayer[window.dataLayer.length -1]
    }else{
        lastDataLayerElement = {}
    }

    let paymentMode 
    if(allJourneyData?.transactionDetails?.transactions){
        paymentMode = allJourneyData?.transactionDetails?.transactions[allJourneyData?.transactionDetails?.transactions?.length - 1]?.paymentMethod
    }else{
        paymentMode = journeyStateData?.paymentDecryptData?.paymentMethod
    }

    let paymentOption 
    if(allJourneyData?.basicDetails?.paymentOption){
        if(allJourneyData?.basicDetails?.paymentOption === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = "paylater"
        }
    }else if(allJourneyData?.paymentStep){
        if(allJourneyData?.paymentStep === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = "paylater"
        }
    }else{
        paymentOption = ""
    }

    let paymentFrequency
    if(journeyStateData?.lastPage === 0 && journeyStateData?.lastSection > 2){
        paymentFrequency = lookup?.premiumFrequency[0][allJourneyData?.productDetails?.premiumFrequency] || ""
    }else if(journeyStateData?.lastPage > 0){
        paymentFrequency = lookup?.premiumFrequency[0][allJourneyData?.productDetails?.premiumFrequency] || ""
    }else{
        paymentFrequency = ""
    }

    // window.dataLayer = []
    if(e === "previous"){
        dynamicEvent = dataLayerLookup?.ISelect360Journey?.[sectionId]?.previousButtonEvent?.eventName 
        }else if(e === "proceed"){
            dynamicEvent = dataLayerLookup?.ISelect360Journey?.[sectionId]?.proceedButtonEvent?.eventName
        }else if(e === "landing"){
            dynamicEvent = dataLayerLookup?.ISelect360Journey?.[sectionId]?.landingPageEvent?.eventName
        }else {
            console.log(dataLayerLookup)
            dynamicEvent = dataLayerLookup?.ISelect360Journey?.[sectionId]?.componentKeyEvent?.[componentFormControlKey]?.eventName
        }
        let pageNameHaveSource = window.location.href?.includes("source")
        if(dynamicEvent === "iSelect_Buy_PersonalDetail_Landed" && !pageNameHaveSource){
            return 
        }

        if(dynamicEvent){
            window.dataLayer.push({
                'event' : dynamicEvent,
                'ProductName': 'iSelect Smart360 Term Plan',
                'ProductCategory': "Term",
                'ProductSubCategory': "Protection",
                'ProductCode': ProductCode,
                'PageType':'Buying Journey',
                'PageName': window.location.href,
                'PolicyType':'Term',
                'SectionName':dataLayerLookup?.ISelect360Journey?.[sectionId]?.sectionName || "",
                'ClientID': clientId,
                'Source': journeyStateData?.channel ? journeyStateData?.channel : "",
                'Usertype': journeyStateData?.dedupeResult === true ? "Returning User" : "New User",
                'Name': allJourneyData?.lifeAssuredDetails?.fullName || "",
                'MobileNumber': encryptedMobileNo,
                'EmailID': encryptedEmail,
                'Gender': lookup?.gender?.[0][allJourneyData?.lifeAssuredDetails?.gender] || "",
                'DOB': dateofbirth ? moment.unix(dateofbirth).format('MM/YYYY') : '',
                'Age': dateofbirth ? getAge(dateofbirth) : '',
                'TobaccoConsumer': lookup['yesNo'][0][allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking] || '',
                'Education': lookup?.education?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.education] || "",
                'AnnualIncome': Number(allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome) || "",
                'ApplicationNumber': allJourneyData?.basicDetails?.applicationNumber || "",
                'SumAssured': Number(allJourneyData?.productDetails?.sumAssured) || "",
                'Term': Number(allJourneyData?.productDetails?.policyTerm) || "",
                'PremiumPaymentTerm': Number(allJourneyData?.productDetails?.premiumPaymentTerm) || "",
                'PaymentFrequency': paymentFrequency || "",
                'PremiumOption': journeyStateData?.premiumOption ? (journeyStateData?.premiumOption === "recommendedOption") ? "Other Recommended Options" : "Calculated Premium" : "",
                'Premium': journeyStateData?.premium ? Math.round((journeyStateData?.premium)/1.18) : "",
                'TotalPremium': journeyStateData?.premium ? Number(journeyStateData?.premium) : "",
                // 'MonthlyPremium': monthlyPremium,
                // 'TotalMonthlyPremium': totalMonthlyPremium,
                'Country': lookup?.countryCodeToCountry?.[0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap] || "",
                'ResidentialStatus': lookup?.residentStatus?.[0][allJourneyData?.lifeAssuredDetails?.residentStatus] || "",
                'PinCode': allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode || "",
                'State': lookup?.state[0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state] || "",
                'Occupation':lookup?.occupation?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation] || "",
                'NatureOfDuties': lookup?.natureOfOccupation?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation] || "",
                'ExistingSumAssured': allJourneyData?.lifeAssuredDetails?.existingSumAssured || "",
                'PlanOption': lookup?.planOption?.[0][allJourneyData?.productDetails?.planOption] || "",
                'CoverageOption': lookup?.coverOption?.[0][allJourneyData?.productDetails?.coverOption] || "",
                'BenefitPayoutOption': lookup?.benefitOption?.[0][allJourneyData?.productDetails?.benefitOption] || "",
                'OptionalBuiltInCover': optionalBuiltInCover,
                'SpouseCover': spouseCover || "",
                'SpouseCoverOptionalBenefits': spouseCover === "YES" ? spouseOptionalBuiltInCover : "",
                'SpouseOccupation': spouseCover === "YES" ? lookup?.occupation?.[0][allJourneyData?.spouseDetails?.employmentDetails?.occupation] || "" : "",
                'SpouseGender': spouse === 'YES' ? lookup?.gender?.[0][allJourneyData?.spouseDetails?.gender] : '',
                'SpouseTobacco': spouseCover === "YES" ? lookup['yesNo'][0][allJourneyData?.spouseDetails?.personalDetails?.smoking] || '' : "",
                'SpouseDOB': spouseCover === "YES" ? spouseDateOfBirth ? moment.unix(spouseDateOfBirth).format('MM/YYYY') : '' : "",
                'SpouseCoverageOption': spouseCover === "YES" ? lookup?.coverOption?.[0][allJourneyData?.productDetails?.spouseLaDetails?.spouseCoverOption] || "" : "",
                'SpouseSumAssured': spouseCover === "YES" ? Number(allJourneyData?.productDetails?.spouseLaDetails?.spouseSa) || "" : "",
                'SpouseResidentialStatus': spouseCover === "YES" ? lookup?.residentStatus?.[0][allJourneyData?.spouseDetails?.residentStatus] || "" : "",
                'SpouseAnnualIncome': spouseCover === "YES" ? Number(allJourneyData?.spouseDetails?.employmentDetails?.annualIncome) || "" : "",
                'SpouseBenefitPayoutOption': spouseCover === "YES" ? lookup?.benefitOption?.[0][allJourneyData?.productDetails?.spouseLaDetails?.spousebenAmtRcvInd] || "" : "",
                'PaymentOption': paymentOption,
                'PaymentMode': paymentMode || lastDataLayerElement?.PaymentMode || "",
                'NatureOfIndustry': lookup?.natureOfIndustry?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry] || "",
                'NomineeDOB': nomineeDateOfBirth ? moment.unix(nomineeDateOfBirth).format('MM/YYYY') : '',
                'NomineeRelationship': allJourneyData?.nominees?.[0]?.relationshipWithLa || "",
                'NomineeGender': lookup?.gender[0][allJourneyData?.nominees?.[0]?.gender] || "",
                'NomineeEmail': nomineeEmailId? MD5(nomineeEmailId)?.toString(): lastDataLayerElement?.NomineeEmail || "",
                // 'NachStatus': (allJourneyData?.basicDetails?.nachStatus === true || allJourneyData?.basicDetails?.nachStatus === "true") ? "Success" : (allJourneyData?.basicDetails?.nachStatus === false ? "Fail" : ""),
                'NachStatus': (allJourneyData?.basicDetails?.isPhysicalMandateOpt === true || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "true") ? (allJourneyData?.basicDetails?.nachStatus === true || allJourneyData?.basicDetails?.nachStatus === "true") ? "Success" : "Fail" : (allJourneyData?.basicDetails?.isPhysicalMandateOpt === false || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "false") ? (allJourneyData?.basicDetails?.enachSuccess === true) ? "Success" : "Fail" : "" ,
                'NachType': (allJourneyData?.basicDetails?.isPhysicalMandateOpt === true || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "true") ? "Physical Mandate" : ((allJourneyData?.basicDetails?.isPhysicalMandateOpt === false || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "false") ? "E-Mandate" : "")

            })
        }
  
}

export const dataLayerRadioIntegration = ( e, sectionId, componentFormControlKey ) => {
    var eventName = dataLayerLookup?.ISelect360Journey?.[sectionId]?.componentKeyEvent?.[componentFormControlKey]?.eventName
    var sectionName = dataLayerLookup?.ISelect360Journey?.[sectionId]?.sectionName
    // window.dataLayer = []
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        "event" : eventName,
        "SectionName" : sectionName
    })
}
export const transformReceiptToTransaction = (receipt, journeyState) => {
    return {
      journeyId: journeyState.journeyId || null,
      applicationNumber: journeyState.applicationNo || null,
      status: receipt.receiptStatus || null,
      srcTraceId: receipt.srcTraceId || null,
      amount: receipt.amount || null,
      paymentTxnId: receipt.transactionNumber || null,
      source: receipt.receiptCreatedBy || null,
      paymentTxnDate: receipt.receiptDate ? new Date(Number(receipt.receiptDate) * 1000).toISOString() : null,
      paymentMethod: receipt.paymentMethod || null,
      receiptNo: receipt.receiptID || null,
      errMsg: null,
      mandateOpt: null,
      mandateTxnId: null,
      mandateTokenId: null,
      mandateId: null,
      mandate: null,
      mandateStatus: null,
      transactionNo: null,
      mercId: null,
    };
  };
